module.exports = __webpack_public_path__ + "img/icons8-trophy-100.c691cee9.png";